import { __decorate } from "tslib";
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
/**
 * @element cipublic-meta-tag-replacer
 */
export class MetaTagReplacer extends CipublicElement {
    render() {
        const metaContent = document.querySelector(`meta[name="${this.metaTag}"]`);
        if (metaContent) {
            return html `${metaContent.getAttribute('content')}`;
        }
        else {
            return html `<slot></slot>`;
        }
    }
}
__decorate([
    property({ reflect: true })
], MetaTagReplacer.prototype, "metaTag", void 0);
//# sourceMappingURL=meta-tag-replacer.js.map